// 引入Vue核心库
import Vue from "vue";
// 引入vue-router
import VueRouter from "vue-router";
// 应用vue-router插件
Vue.use(VueRouter);

// 引入组件（方式一）
import page1 from "../views/page1.vue";
import page2 from "../views/page2.vue";

import page5 from "../views/page5.vue";
import page6 from "../views/page6.vue";
import page7 from "../views/page7.vue";
import page8 from "../views/page8.vue";
import page9 from "../views/page9.vue";

import page11 from "../views/page11.vue";


import xiyatu from "../views/xiyatu.vue";
import scoreOld from "../views/score-old.vue";
import scoreXiyatu from "../views/score-xiyatu.vue";
import scoreSuzhou from "../views/score-suzhou.vue";
import nanjingOld from "../views/nanjing-old.vue";
import nanjingEn from "../views/nanjing-en.vue";
import rank from "../views/rank.vue";
import rankEn from "../views/rank-xiyatu.vue";
import rank4k from "../views/rank-4k.vue";
import huangpu from "../views/huangpu.vue";
//跳跳界面
// import page10 from "../views/score.vue";
// import nanjing from "../views/nanjing.vue";
// import score from "../views/score.vue";
// import page3 from "../views/page3.vue";
// import page4 from "../views/page4.vue";
//跳跳英文
import page10 from "../views/score-en.vue";
import nanjing from "../views/nanjing-en.vue";
import score from "../views/score-en.vue";
import page3 from "../views/page3-xiyatu.vue";
import page4 from "../views/page4-xiyatu.vue";
import room from "../views/score-room.vue";
//美国界面
// import score from "../views/score-xiyatu.vue";
// import page10 from "../views/score-xiyatu.vue";
// import nanjing from "../views/xiyatu.vue";
// import page3 from "../views/page3-xiyatu.vue";
// import page4 from "../views/page4-xiyatu.vue";
//跳跳苏州
// import score from "../views/score-suzhou.vue";
// import page10 from "../views/score-suzhou.vue";
// import nanjing from "../views/suzhou.vue";
// import page3 from "../views/page3.vue";
// import page4 from "../views/page4.vue";
// 配置路由
const routes = [
  {
    // 路径，/ 表示首页
    path: "/huangpu",
    // 使用组件（方式一）
    component: huangpu,
  }, 
    {
    // 路径，/ 表示首页
    path: "/room",
    // 使用组件（方式一）
    component: room,
  }, 
  {
    // 路径，/ 表示首页
    path: "/nanjingEn",
    // 使用组件（方式一）
    component: nanjingEn,
  }, {
    // 路径，/ 表示首页
    path: "/score-xiyatu",
    // 使用组件（方式一）
    component: scoreXiyatu,
  }, {
    // 路径，/ 表示首页
    path: "/score-old",
    // 使用组件（方式一）
    component: scoreOld,
  }, {
    // 路径，/ 表示首页
    path: "/score-suzhou",
    // 使用组件（方式一）
    component: scoreSuzhou,
  },
  {
    // 路径，/ 表示首页
    path: "/xiyatu",
    // 使用组件（方式一）
    component: xiyatu,
  },
  {
    // 路径，/ 表示首页
    path: "/score",
    // 使用组件（方式一）
    component: score,
  },
  {
    // 路径，/ 表示首页
    path: "/nanjing",
    // 使用组件（方式一）
    component: nanjing,
  },
  {
    // 路径，/ 表示首页
    path: "/nanjingOld",
    // 使用组件（方式一）
    component: nanjingOld,
  },
  {
    // 路径，/ 表示首页
    path: "/",
    // 使用组件（方式一）
    component: page1,
  },
  {
    // 路径，/ 表示首页
    path: "/page2",
    // 使用组件（方式一）
    component: page2,
  },
  {
    // 路径，/ 表示首页
    path: "/page3",
    // 使用组件（方式一）
    component: page3,
  },
  {
    // 路径，/ 表示首页
    path: "/page4",
    // 使用组件（方式一）
    component: page4,
  },
  {
    // 路径，/ 表示首页
    path: "/page5",
    // 使用组件（方式一）
    component: page5,
  },
  {
    // 路径，/ 表示首页
    path: "/page6",
    // 使用组件（方式一）
    component: page6,
  },
  {
    // 路径，/ 表示首页
    path: "/page7",
    // 使用组件（方式一）
    component: page7,
  },
  {
    // 路径，/ 表示首页
    path: "/page8",
    // 使用组件（方式一）
    component: page8,
  },
  {
    // 路径，/ 表示首页
    path: "/page9",
    // 使用组件（方式一）
    component: page9,
  },
  {
    // 路径，/ 表示首页
    path: "/page10",
    // 使用组件（方式一）
    component: page10,
  },
  {
    // 路径，/ 表示首页
    path: "/page11",
    // 使用组件（方式一）
    component: page11,
  },
  {
    // 路径，/ 表示首页
    path: "/rank",
    // 使用组件（方式一）
    component: rank,
  },{
    // 路径，/ 表示首页
    path: "/rankEn",
    // 使用组件（方式一）
    component: rankEn,
  },{
    // 路径，/ 表示首页
    path: "/rank4k",
    // 使用组件（方式一）
    component: rank4k,
  },
  
];

// 创建路由器
const router = new VueRouter({
  routes,
});

// 导出路由器
export default router;
